import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { WrittenPrescriptionInput } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useSaveWrittenPrescription() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ treatmentId, ...body }: WrittenPrescriptionInput) => {
      const response = await api.post('/treatments/:id/external-scripts', {
        params: { id: treatmentId },
        body,
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data.note
    },
    onSuccess: (note) => {
      queryClient.invalidateQueries({ queryKey: ['patient-files', note.patientId] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', note.patientId] })
      if (note.consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', note.consultationId] })
      }
    },
  })
}
